// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__uC2hY","imageWrapper":"styles_imageWrapper__ZqSG9","image":"styles_image__WhY-U","title":"styles_title__6WvAE","description":"styles_description__1tBhi"};